import { useCurrentUserStore } from '@/stores/currentUser.ts';
import type { MenuGroup } from '@/components/shared/sidebar/sidebar_menu';
import { computed } from 'vue';

export const useSettingsSidebar = () => {
  const currentUserStore = useCurrentUserStore();

  const getDefaultGroups = () => {
    const isNotContributor = !currentUserStore.isContributor();
    const isAdminImpersonating = currentUserStore.isImpersonating() && currentUserStore.isAdmin();

    const defaultItems: MenuGroup[] = [
      {
        show: true,
        items: [
          {
            title: 'Guided Account Setup',
            url: '/settings',
            show: true,
          },
        ],
      },
      {
        label: 'Account',
        show: true,
        items: [
          {
            title: 'Profile',
            url: '/settings/account/profile',
            show: true,
          },
          {
            title: 'Email',
            url: '/settings/account/email',
            show: true,
          },
          {
            title: 'Calendar',
            url: '/settings/account/calendar',
            show: true,
          },
          {
            title: 'Notifications',
            url: '/settings/account/notifications',
            show: true,
          },
        ],
      },
      {
        label: 'Company',
        show: isNotContributor,
        items: [
          {
            title: 'Profile',
            url: '/settings/company/profile',
            show: true,
          },
          {
            title: 'Users',
            url: '/settings/company/users',
            show: true,
          },
          {
            title: 'Billing',
            url: '/settings/company/billing',
            show: true,
          },
          {
            title: 'Scheduling',
            url: '/settings/company/scheduling',
            show: true,
          },
          {
            title: 'Landing Pages',
            url: '/settings/company/landing_pages',
            show: true,
          },
          {
            title: 'Advertising',
            url: '/settings/company/advertising',
            show: true,
          },
          {
            title: 'Onboarding Tasks',
            url: '/settings/company/onboarding_checklists',
            show: true,
          },
          {
            title: 'Offboarding Tasks',
            url: '/settings/company/offboarding_checklists',
            show: true,
          },
          {
            title: 'Training Tasks',
            url: '/settings/company/training_checklists',
            show: true,
          },
        ],
      },
      {
        label: 'Workflows',
        show: isNotContributor,
        items: [
          {
            title: 'Candidate',
            url: '/settings/workflows/candidate',
            show: true,
          },
          {
            title: 'Team',
            url: '/settings/workflows/team',
            show: true,
          },
          {
            title: 'Pipeline Reviews',
            url: '/settings/workflows/pipeline-reviews',
            show: true,
          },
        ],
      },
      {
        label: 'Data Management',
        show: isNotContributor,
        items: [
          {
            title: 'Custom Fields',
            url: '/settings/data/custom_fields',
            show: true,
          },
        ],
      },
      {
        label: 'Templates',
        show: isNotContributor,
        items: [
          {
            title: 'Email',
            url: '/settings/templates/email',
            show: true,
          },
          {
            title: 'SMS',
            url: '/settings/templates/sms',
            show: true,
          },
          {
            title: 'E-signature',
            url: '/settings/templates/esignature',
            show: true,
          },
        ],
      },
      {
        label: 'Integrations',
        show: isAdminImpersonating,
        items: [
          {
            title: 'PandaDoc',
            url: '/settings/integrations/pandadoc',
            show: true,
          },
          {
            title: 'Stripe',
            url: '/settings/integrations/stripe',
            show: true,
          },
          {
            title: 'Telco',
            url: '/settings/integrations/telco',
            show: true,
          },
          {
            title: 'Website',
            url: '/settings/integrations/website',
            show: true,
          },
        ],
      },
    ];
    return defaultItems;
  };

  const agentGroups = (): MenuGroup[] => [];

  const menuGroups = computed(() => (currentUserStore.isAgent() ? agentGroups() : getDefaultGroups()));

  return { menuGroups };
};
